import React from 'react';
import { LuFolder } from "react-icons/lu";

const SectionItem = ({ 
  name, 
  icon = LuFolder, 
  iconColor = "blue-400",
  onClick 
}) => {
  const Icon = icon;
  
  return (
    <div 
      onClick={onClick}
      className="flex items-center space-x-3 p-3 hover:bg-[#ffffff10] rounded-lg cursor-pointer transition-colors group"
    >
      <div className={`p-2 bg-${iconColor}/20 rounded-lg group-hover:bg-${iconColor}/30 transition-colors`}>
        <Icon className={`w-5 h-5 text-${iconColor}`} />
      </div>
      <div className="text-lg font-medium text-white">{name}</div>
    </div>
  );
};

export default SectionItem;